import React from "react"
import { Popover } from "react-bootstrap"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import FieldTypes from "../Types/FieldTypes"
import paletteEngine from "./paletteEngine"

const formStatus = {
    /* A function that returns an object. */
    getFormStatus: (template: Array<Array<FieldTypes>> | [], palette: Array<DynamicFormPaletteTypes>) => {
        let missing = []
        let finished = 0
        let required = 0
        for (let i = 0; i < template.length; i++) {
            let row = template[i]
            for (let j = 0; j < row.length; j++) {
                let col: FieldTypes = row[j]
                if (col.Required && !col.Value) {
                    missing.push(col)
                    required++
                } else if (col.Required && col.Value) {
                    finished++
                    required++
                }
            }
        }
        const status = {
            canSubmit: missing.length === 0,
            missing: missing,
            popover: formStatus.statusPopover(missing, palette),
            progress: required > 0 ? (Math.round((((finished / required) * 100) + Number.EPSILON) * 100) / 100) : -1,
        }
        return status
    },
    /* A function that returns a React component. */
    statusPopover: (missing: Array<FieldTypes>, palette: Array<DynamicFormPaletteTypes>) => {
        return (
            <Popover id="dynamic-form-missing-fields-popover" style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
                <Popover.Title as="h2" style={{ color: `${paletteEngine.getPaletteColor("missingFieldsPopoverHeaderColor")}`, backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>Please provide a value for the following fields:</Popover.Title>
                {missing.map((item, index: number) =>
                    <div className="DynamicFormMissingFieldsPopoverText" key={`missing-form-item-${index}`}
                        style={{ backgroundColor: `${index % 2 === 0 ? paletteEngine.getPaletteColor("fieldBackgroundColor") : paletteEngine.getPaletteColor("missingFieldsPopoverOddRow")}`, color: `${paletteEngine.getPaletteColor("missingFieldsPopoverTextColor")}` }}
                    >
                        {`${index + 1}. ${item.Name}`}
                    </div>)}
            </Popover>
        )
    }
}

export default formStatus